import { Component, Input, OnInit } from '@angular/core';
import { StickyBanner } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';

@Component({
  selector: 'app-sample-sticky-bunner',
  templateUrl: './sample-sticky-bunner.component.html',
  styleUrls: ['./sample-sticky-bunner.component.scss']
})
export class SampleStickyBannerComponent implements OnInit {

  @Input() block: StickyBanner = {} as StickyBanner;
  public isOpen: boolean = true;
  public isLinkEsternal: boolean = false;

  constructor(
    public helperService: HelpersService, 
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.isLinkEsternal = this.block.link_cta ? this.helperService.verifyLinkExternal(this.block.link_cta.url) : false;
  }

  closeSticky() {
    this.isOpen = false;
  }

  setTypeSticky(type?: string): string {
    let typeButton: string;
    switch (type) {
      case "Urgente":
        typeButton = 'ls-danger';
        break;
      case "Attenzione":
        typeButton = 'ls-warning';
        break;
      case "Successo":
        typeButton = 'ls-success';
        break;
      default:
        typeButton = 'ls-light';
        break;
    }
    return typeButton;
  }

}
